import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { List, Text } from '@mantine/core';
import { IconPointFilled } from '@tabler/icons-react';
import classes from './GamePanel.module.css';
export const GameKeyFuturePanel: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <List classNames={{
    item: classes.item,
    itemIcon: classes.itemIcon
  }} icon={<IconPointFilled size={20} color="var(--text-prime)" />}>
      <List.Item>
        <Text fz="xs" c="var(--text-prime)" className={gunterzBold.className}>
          {i18n._('Tumble Feature:')}
        </Text>
        <Text fz="xs" c="var(--text-dark)">
          {i18n._('Winning symbols disappear, allowing new ones to fall for potential multiple wins per spin.')}
        </Text>
      </List.Item>

      <List.Item>
        <Text fz="xs" c="var(--text-prime)" className={gunterzBold.className}>
          {i18n._('Scatter Symbols:')}
        </Text>
        <Text fz="xs" c="var(--text-dark)">
          {i18n._('The giant lollipop scatter can trigger free spins and big payouts.')}
        </Text>
      </List.Item>

      <List.Item>
        <Text fz="xs" c="var(--text-prime)" className={gunterzBold.className}>
          {i18n._('Free Spins Round:')}
        </Text>
        <Text fz="xs" c="var(--text-dark)">
          {i18n._('Get 4 or more scatters to enter the free spins bonus, where multiplier candy bombs can boost your wins.')}
        </Text>
      </List.Item>

      <List.Item>
        <Text fz="xs" c="var(--text-prime)" className={gunterzBold.className}>
          {i18n._('Ante Bet:')}
        </Text>
        <Text fz="xs" c="var(--text-dark)">
          {i18n._('Increase your chances of hitting scatters by activating this feature.')}
        </Text>
      </List.Item>

      <List.Item>
        <Text fz="xs" c="var(--text-prime)" className={gunterzBold.className}>
          {i18n._('Symbols and Payouts:')}
        </Text>
        <Text fz="xs" c="var(--text-dark)">
          {i18n._('From juicy fruit candies to sweet heart shapes, match 8-12+ symbols for payouts ranging from 0.25x to 50x your bet!')}
        </Text>
      </List.Item>
    </List>;
};